<div class="rounded-lg border border-ui-gray-light px-3 py-2 flex items-center">
  <avs-energy-icon
    [type]="config().type"
    size="medium"
  />
  <div class="ml-3 flex flex-col">
    <span class="text-ui-dark font-semibold text-sm">{{ config().value | avsEnergyValue: 'kWh' }}</span>
    <span class="text-ui-gray-100 font-semibold text-xs capitalize">{{ config().type }} @if(config().showFullTitle) {
        Energy Consumption
      }</span>
  </div>
</div>
